<template>
  <v-card v-if="donation && donation.paymentSpecification" class="mx-10 my-5" variant="outlined">
    <div v-if="isImage">
      <v-img :src="getInvoice()" lazy-src="https://picsum.photos/128/?blur=5" />
    </div>

    <div v-else>
      <iframe
        frameborder="0"
        :src="getInvoice()"
        type="application/pdf"
        width="100%"
        style="height: 60vh"
      />
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { useInvoiceOperations } from '@/composables/useInvoiceOperations';

import store from '@/store';

export default defineComponent({
  name: 'InvoiceComponent',
  components: {},
  props: {
    isImage: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['reset'],
  setup(props, { emit }) {
    const loading = ref(false);

    const { getInvoiceDocumentUrl } = useInvoiceOperations();

    const requestSession = computed(() => {
      return store.state.requestSession;
    });

    const donation = computed(() => {
      return store.state.donation;
    });

    const currentStep = computed(() => {
      return store.state.currentStep;
    });

    const reset = () => {
      emit('reset');
    };

    const getInvoice = (): string => {
      if (!donation.value) return '';
      return getInvoiceDocumentUrl(donation.value.serialnumber, props.isImage, 'inline');
    };

    return {
      loading,
      requestSession,
      donation,
      currentStep,
      reset,
      getInvoice,
    };
  },
});
</script>
